module.exports = __webpack_public_path__ + "img/Venue-Overview-BG.5dcba608.jpg";